"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconButton = exports.classes = void 0;
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const styles_1 = require("@mui/material/styles");
const PREFIX = "IconButton";
exports.classes = {
    root: `${PREFIX}-root`,
    text: `${PREFIX}-text`,
    contained: `${PREFIX}-contained`,
    textDarkBg: `${PREFIX}-textDarkBg`,
    "extra-small": `${PREFIX}-extra-small`,
    small: `${PREFIX}-small`,
    42: `${PREFIX}-42`,
    medium: `${PREFIX}-medium`,
    large: `${PREFIX}-large`,
    "extra-large": `${PREFIX}-extra-large`
};
exports.StyledIconButton = (0, styles_1.styled)(IconButton_1.default)(({ theme: { colours, palette } }) => {
    const iconButtonBuffer = (margin) => ({
        "&::after": {
            content: "''",
            position: "absolute",
            top: -margin,
            left: -margin,
            bottom: -margin,
            right: -margin
        }
    });
    return {
        [`&.${exports.classes.root}`]: {
            borderRadius: 3,
            padding: 0,
            "&:hover": {
                backgroundColor: colours.focus
            },
            "&.Mui-disabled": {
                backgroundColor: (0, styles_1.alpha)(colours.focus, 0.35)
            }
        },
        [`&.${exports.classes.contained}`]: {
            backgroundColor: palette.primary.main,
            color: colours.white
        },
        [`&.${exports.classes.text}`]: {
            backgroundColor: "none",
            color: "currentColor",
            "&:hover": {
                backgroundColor: (0, styles_1.alpha)(colours.white, 0.05)
            }
        },
        [`&.${exports.classes.textDarkBg}`]: {
            color: colours.white,
            "&:hover": {
                backgroundColor: (0, styles_1.alpha)(colours.white, 0.1)
            }
        },
        [`&.${exports.classes["extra-small"]}`]: {
            maxWidth: 24,
            maxHeight: 24,
            ...iconButtonBuffer(12)
        },
        [`&.${exports.classes.small}`]: {
            maxWidth: 32,
            maxHeight: 32,
            ...iconButtonBuffer(8)
        },
        [`&.${exports.classes["42"]}`]: {
            width: 42,
            height: 42
        },
        [`&.${exports.classes.medium}`]: {
            width: 48,
            height: 48
        },
        [`&.${exports.classes.large}`]: {
            width: 60,
            height: 60
        },
        [`&.${exports.classes["extra-large"]}`]: {
            width: 64,
            height: 64
        }
    };
});
//# sourceMappingURL=data:application/json;base64,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